import type { GameMode } from '@interactive-room';

export type PrintBlockRole = 'teaching' | 'practice' | 'neutral';

const TEACHING_MODES = new Set<string>([
  'info_block',
  'subtitulo',
  'destacado',
  'figura',
  'glosario_tabla',
  'canvas_breakdown',
  'structural_breakdown',
  'source_analysis',
  'formula_destacada',
]);

const PRACTICE_MODES = new Set<string>([
  'arena',
  'poll',
  'completar',
  'vincula',
  'agrupa',
  'order',
  'desarrollo',
  'dictado',
  'sandbox',
  'data_chart',
  'math_equation',
  'geometry_canvas',
  'cartesian_plane',
  'fraction_model',
  'percent_grid',
  'number_line',
  'counting_collection',
  // Música nativa — antes caían en "neutral" y usaban index+1 (rompe 1,3,4,2…).
  'anatomia',
  'rhythm_canvas',
  'melody_staff',
  'ear_training',
  'symbol_analysis',
]);

export function resolvePrintBlockRole(mode: GameMode | string): PrintBlockRole {
  const key = String(mode || '').toLowerCase();
  if (TEACHING_MODES.has(key)) return 'teaching';
  if (PRACTICE_MODES.has(key)) return 'practice';
  return 'neutral';
}

export function getTeachingBlockBadge(mode: GameMode | string): string {
  switch (mode) {
    case 'info_block':
      return 'Contexto';
    case 'destacado':
      return 'Concepto clave';
    case 'formula_destacada':
      return 'Fórmula';
    case 'subtitulo':
      return 'Sección';
    case 'figura':
      return 'Ilustración';
    case 'glosario_tabla':
      return 'Glosario';
    default:
      return 'Enseñanza';
  }
}

export function findFirstPracticeBlockIndex(
  blocks: Array<{ mode?: string }>,
): number {
  return blocks.findIndex((block) => resolvePrintBlockRole(block.mode || '') === 'practice');
}
